// ============================================================
// Failure Chain Page - AIAG-VDA Step 4
// ============================================================
// Wrapper page for the Failure Chain Editor component
// Part of the Golden Thread workflow
// ============================================================

import React from 'react';
import FailureChainEditor from '../components/FailureChainEditor';

const FailureChainsPage: React.FC = () => {
    return (
        <div className="h-full">
            <FailureChainEditor />
        </div>
    );
};

export default FailureChainsPage;
